import * as constants from './actions';
import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    actionInitated: false,
    actionCompleted: false,
    videoPlaying: false,
    videosCompleted: []
};

export default function video(state = initialState, { type, payload }) {
    switch (type) {
        case constants.VIDEO_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                videoPlaying: true,
                timeUntilStart: getTimeFrom(state[`initiatedTime_${payload}`]),
                actionInitiated: true,
                actionCompleted: false
            };
        case constants.VIDEO_PLAY:
            return {
                ...state,
                videoPlaying: true
            };
        case constants.VIDEO_PAUSED:
            return {
                ...state,
                videoPlaying: false
            };
        case constants.VIDEO_COMPLETED:
            return {
                ...state,
                videoPlaying: false,
                actionCompleted: true,
                timeUntilCompletion: getTimeFrom(state[`initiatedTime_${payload}`]),
                videosCompleted: state.videosCompleted.push(payload)
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/containers/Video/reducer.js